"use strict";

exports.__esModule = true;
exports.shortenTimeRelativeMomentExpression = shortenTimeRelativeMomentExpression;

function shortenTimeRelativeMomentExpression(moment) {
  function updateLocale(locale, overrides) {
    moment.updateLocale(locale, {
      relativeTime: overrides
    });
  }

  updateLocale('en', {
    s: '1s',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd'
  });
  updateLocale('nl', {
    s: '1sec.',
    ss: '%dsec.',
    m: '1min.',
    mm: '%dmin.',
    h: '1u.',
    hh: '%du.' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('cs', {
    s: '1sek',
    ss: '%dsek',
    m: '1min',
    mm: '%dmin',
    h: '1hod',
    hh: '%dhod' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('da', {
    s: '1s',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1t',
    hh: '%dt' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('de', {
    s: '1Sek.',
    ss: '%dSek.',
    m: '1Min.',
    mm: '%dMin.',
    h: '1Std.',
    hh: '%dStd.' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('fr', {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('hi', {
    s: '1से',
    ss: '%dसे',
    m: '1मि',
    mm: '%dमि',
    h: '1घंटा',
    hh: '%dघंटा' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('it', {
    s: '1sec',
    ss: '%dsec',
    m: '1min',
    mm: '%dmin',
    h: '1ora',
    hh: '%dore' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('ja', {
    s: '1秒',
    ss: '%d秒',
    m: '1分',
    mm: '%d分',
    h: '1時間',
    hh: '%d時間' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('ko', {
    s: '1초',
    ss: '%d초',
    m: '1분',
    mm: '%d분',
    h: '1시간',
    hh: '%d시간' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('nb', {
    s: '1sek',
    ss: '%dsek',
    m: '1min',
    mm: '%dmin',
    h: '1time',
    hh: '%dtimer' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('pl', {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('pt', {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('es', {
    s: '1seg',
    ss: '%dseg',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dhs' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('sv', {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('th', {
    s: '1วินาที',
    ss: '%dวินาที',
    m: '1นาที',
    mm: '%dนาที',
    h: '1ชั่วโมง',
    hh: '%dชั่วโมง' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('tr', {
    s: '1sn.',
    ss: '%dsn.',
    m: '1dk.',
    mm: '%ddk.',
    h: '1sa.',
    hh: '%dsa.' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('ru', {
    s: '1сек.',
    ss: '%dсек.',
    m: '1dмин.',
    mm: '%dмин.',
    h: '1ч.',
    hh: '%dч.' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('zh-cn', {
    s: '1秒',
    ss: '%d秒',
    m: '1d分鐘',
    mm: '%d分鐘',
    h: '1小時',
    hh: '%d小時' // d: '1d',
    // dd: '%dd',

  });
  updateLocale('uk', {
    s: '1с.',
    ss: '%dс.',
    m: '1dхв.',
    mm: '%dхв.',
    h: '1г.',
    hh: '%dг.' // d: '1d',
    // dd: '%dd',

  });
  moment.relativeTimeThreshold('ss', 59); // will say 1s until a minute

  moment.relativeTimeThreshold('m', 59); // will say minutes until it's over 59m

  moment.relativeTimeThreshold('h', 23); // will say hours until it's over 23h
}